window.GiftCardPostman = window.GiftCardPostman || {}

class GiftCardPostman {
  constructor(data) {
    this.data = data
    this.settings = {
      checksum_property_title: "_gcp_checksum",
      extra_input_field_ids: ['sender_name', 'recipient_email', 'scheduled_at', 'message', 'gift_card_value']
    }
    this.selectors = {
      appInput: '.gift-card-postman__fields-container input, .gift-card-postman__fields-container textarea',
      storeForm: 'form[action="/cart/add"]',
      giftCheckbox: '[id="gift_option"]'
    }
    this.giftCardProperties = {}
    this.bindInputListeners.bind(this);
    
    this.bindInputListeners();
    document.querySelector(this.selectors.giftCheckbox).dispatchEvent(new Event('input', { bubbles: true, cancelable: true }))
    setTimeout(() => {
      document.querySelectorAll(this.selectors.appInput).forEach((el) => {
        if (el.type !== 'datetime-local') {
          el.value = null
        }
      })
    }, 500)
  }


  bindInputListeners() {
    self = this
    document.querySelectorAll(this.selectors.appInput).forEach((el) => {
      el.addEventListener("input", this.inputChanged.bind(this))
    })    
  }

  inputChanged(event) {
    const inputName = event.target.name;
    const inputValue = event.currentTarget.type == 'checkbox' ? event.currentTarget.checked : event.target.value;
    const inputId = event.target.id
    const giftCardPostmanHiddenFieldSelector = `input[type="hidden"][name="properties[${this.settings.checksum_property_title}]"]`
    this.giftCardProperties[inputId] = inputValue;
    const sectionElement = event.target.closest('section') 
      || event.target.closest('.shopify-section') 
      || document.querySelector('.product-section')
    const forms = sectionElement.querySelectorAll(this.selectors.storeForm)
    var self = this
    const isGiftOptionDeselected = inputName === "properties[_gift_option]" && !event.currentTarget.checked
    if(isGiftOptionDeselected) {
      const fieldsToRemove = self.settings.extra_input_field_ids.map(id => document.querySelector(`.gcp-form-fields #${id}`).name)
      fieldsToRemove.map(fieldToRemove => {
        document.querySelectorAll(`input[type="hidden"][name="${fieldToRemove}"]`).forEach(el => el.remove())
      })
      document.querySelectorAll(giftCardPostmanHiddenFieldSelector).forEach(el => el.remove())
      document.querySelectorAll(this.selectors.appInput).forEach((el) => {
        el.value = null
      })
    } 
    forms.forEach(el => {
      const selector = `input[type="hidden"][name="${inputName}"]`
      const inputExists = el.querySelectorAll(selector);
      if(inputExists.length) {
        if(inputValue || event.currentTarget.type == 'checkbox') {
          inputExists[0].value = inputValue
        } else {
          inputExists[0].remove();
        }
      } else {
        var input = document.createElement('input')
        input.type = "hidden"
        input.name = inputName
        input.value = inputValue
        el.appendChild(input)
      }
      if(!isGiftOptionDeselected) {
        const giftCardPostmanHiddenField = el.querySelectorAll(giftCardPostmanHiddenFieldSelector);
        const checksum = btoa(unescape(encodeURIComponent(JSON.stringify(this.giftCardProperties))))
        if(giftCardPostmanHiddenField.length) {
          giftCardPostmanHiddenField[0].value = checksum
        } else {
          var gcpInput = document.createElement('input')
          gcpInput.type = "hidden"
          gcpInput.name = `properties[${self.settings.checksum_property_title}]`
          gcpInput.value = checksum
          el.appendChild(gcpInput)
        }
      }
    })
  }
}

// custom code
const receiverButtons = document.querySelectorAll('.receiver-btn')
const deliveryButtons = document.querySelectorAll('.delivery-btn')
const giftCheckbox = document.querySelector('#gift_option')
const datePicker = document.querySelector('#scheduled_at')

const getCurrentDate = () => {
  const now = new Date();
  now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
  now.setMilliseconds(null)
  now.setSeconds(null)

  return now
}

const setCurrentTime = () => {
  datePicker.value = getCurrentDate().toISOString().slice(0, -1);
  datePicker.dispatchEvent(new Event('input'));
}

const changeActiveBtn = (clickedBtn) => {
  if (clickedBtn.classList.contains('receiver-btn')) {
    receiverButtons.forEach(btn => {
      btn.classList.remove('active')
    })
  }

  if (clickedBtn.classList.contains('delivery-btn')) {
    deliveryButtons.forEach(btn => {
      btn.classList.remove('active')
    })
  }

  clickedBtn.classList.add('active')
}

const changeReceiver = (e) => {
  changeActiveBtn(e.target)

  if (e.target.classList.contains('for-customer')) {
    giftCheckbox.checked = false
    datePicker.value = null
    datePicker.dispatchEvent(new Event('input'));
    return
  }
  giftCheckbox.checked = true
}

const changeDeliveryTime = (e) => {
  changeActiveBtn(e.target)

  if (e.target.classList.contains('now')) {
    setCurrentTime()
    datePicker.classList.add('hidden')
    return
  }
  setCurrentTime()
  datePicker.classList.remove('hidden')
}

receiverButtons.forEach(btn => {
  btn.addEventListener('click', changeReceiver)
})

deliveryButtons.forEach(btn => {
  btn.addEventListener('click', changeDeliveryTime)
})

onload = () => {
  setCurrentTime()
}